import {Component, OnInit, ViewChild} from '@angular/core';
import {FabTableState, filterStateChange, process} from "@fabric/components/table-filter/data-query";
import {MatTableDataSource} from "@angular/material/table";
import {ViewRemitos} from "../../models/ViewRemitos";
import {OpenItem} from "../../models/OpenItem";
import {FormControl, FormGroup, FormGroupDirective} from "@angular/forms";
import {map, Observable, startWith} from "rxjs";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {NotificationService} from "../../services/notification.service";
import {SecurityService} from "../../services/security.service";
import {RemitoService} from "../../services/remito.service";
import {AlmacenService} from "../../services/almacen.service";
import {OpenItemService} from "../../services/open-item.service";
import {Almacen} from "../../models/Almacen";
import {Solicitante} from "../../models/Solicitante";
import {Remito} from "../../models/Remito";
import {SolicitanteService} from "../../services/solicitante.service";
import {FabDateFilterOperator} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {FabStringFilterOperator} from '../../shared-components/table-filter/string-filter/string-filter.component';

@Component({
  selector: 'app-open-items-report',
  templateUrl: './open-items-report.component.html',
  styleUrls: ['./open-items-report.component.scss']
})
export class OpenItemsReportComponent implements OnInit {

    @ViewChild('formDirective') private formDirective: FormGroupDirective;

    displayedColumns: string[] = [
        'almacen', 'origen', 'ptoEmision', 'nroRemito', 'fecGen', 'fecARetornar', 'fecSalida', 'cantProrrogas',
        'ultFecProrroga', 'motivo', 'dock', 'solicitante', 'destino', 'transporte', 'comentario', 'nroTicket'
    ];
    dataSource: MatTableDataSource<ViewRemitos> = new MatTableDataSource<ViewRemitos>();
    operators: FabStringFilterOperator[] = ['contains'];
    almacenOptions: string[] = []
    chosenAlmacens: string[] = []
    selectedAlmacens: string = ""
    public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
    state: FabTableState = {
        skip: 0,
        take: 5,
        filter: [],
        sort: []
    };
    openItems: OpenItem[] = [];
    solicitantes: Solicitante[] = [];
    almacenes: Almacen[] = [];
    filteredSoilicitante: Observable<Solicitante[]> | undefined;

    solicitanteControl = new FormControl<string | Solicitante>('');
    almacenControl = new FormControl<string[]>([]);
    fecARetornarControl = new FormControl<Date | null>(null);

    openItemsReportForm: FormGroup = new FormGroup({
        solicitante: this.solicitanteControl,
        almacen: this.almacenControl,
        fecARetornar: this.fecARetornarControl
    })

    almacenSelected: boolean = false;
    searchCriteriaSelected: boolean = false;
    validationErrorMessage: string = '';
    printRemito: boolean = false;
    remitos: Remito;
    isLoading: boolean = false;

    @ViewChild(MatPaginator) private paginator: MatPaginator;
    showReportData: boolean = false;


    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }

    constructor(private notificationService: NotificationService,
                private securityService: SecurityService,
                private remitoService: RemitoService,
                private solicitanteService: SolicitanteService,
                private almacenService: AlmacenService,
                private openItemService: OpenItemService) {
    }

    ngOnInit(): void {
        this.getAlmacens();
        this.getSolicitantes();
    }

    private fetchData() {
        this.dataSource.data = process(this.openItems, this.state)
    }

    public filterChange(event: any) {
        this.state.skip = 0;
        // @ts-ignore
        this.state.filter = filterStateChange(event, this.state.filter);
        this.filterData();
    }

    private filterData() {
        this.dataSource.data = process(this.openItems, this.state)
    }


    solicitanteSelection(inputId: string) {
        if (inputId != null && inputId != "" && inputId != "-1") {
            const solicitante = this.solicitantes.find(o => o.idSolicitante === inputId) ?? new Solicitante();
            let resultAlmacen: Almacen = solicitante.almacen;

            this.almacenControl.setValue([resultAlmacen.codAlmacen + ' - ' + resultAlmacen.descAlmacen]);
            this.almacenControl.disable();
        } else {
            this.almacenControl.enable();
        }

    }

    getAlmacens() {
        //let almas: string[] = [];
        this.almacenService.getAll().subscribe((response) => {
            this.almacenes = response;
            for (let i = 0; i < this.almacenes.length; i++) {
                {
                    //almas.push(this.almacenes[i].codAlmacen + " " + this.almacenes[i].descAlmacen);
                    this.almacenOptions.push(this.almacenes[i].codAlmacen + " - " + this.almacenes[i].descAlmacen);
                }
            }
            //this.almacenControl.setValue(almas);
        });
    }

    onChangeAlmacen(almacens: string[]) {
        this.almacenSelected = true;
        if (this.almacenControl.value != almacens) {
            this.almacenControl.setValue(almacens);
        }
    }

    getSolicitantes() {

        this.solicitanteService.getSolicitantes().subscribe((response) => {
            //this.solicitantes = response;
            for (let i = 0; i < response.length; i++) {
                {
                    this.solicitantes.push(response[i]);
                    //this.solicitanteControl.setValue(this.solicitantes[i].idSolicitante + " " + this.solicitantes[i].solicitante)
                }
                this.populateSolicitante();
            }
        });
    }

    onChangeSolicitante(solicitante: any) {
        this.almacenControl.enable();
        this.almacenControl.setValue([]);
        this.solicitanteControl.setValue(solicitante.value);
    }

    populateSolicitante() {
        this.filteredSoilicitante = this.solicitanteControl.valueChanges.pipe(
            startWith(''),
            map(value => {
                //const solicitanteValue = typeof value === 'string' ? value : value?.id;
                const solicitanteValue = value;
                return solicitanteValue ? this.solicitanteFiltering(solicitanteValue as string) : this.solicitantes.slice();
            }),
        );
    }

    private solicitanteFiltering(input: string): Solicitante[] {
        const filterValue = input.toLowerCase();
        return this.solicitantes.filter(option => option.solicitante.toLowerCase().includes(filterValue) || option.idSolicitante.toLowerCase().includes(filterValue));
    }


    search() {

        this.getSearchData();
        this.validateSearchData();

        if (this.validationErrorMessage != '') {
            this.notificationService.open(this.validationErrorMessage, 'error');
            this.isLoading = false;
        } else {
            this.openItemService.generateReport(this.remitos).subscribe((response) => {
                this.openItems = response;
                this.displayData();
                this.checkPrintedRemito();
            });
        }
    }

    printOpenRemitos() {
        this.isLoading = true;
        this.printRemito = true;
        this.search();
    }

    validateSearchData() {

        this.validationErrorMessage = '';

        if (this.remitos.idSolicitante == '-1' && this.remitos.almacens[0] == '' && this.remitos.fecARetornar == null) {
            //Please enter at least ONE search criteria to continue!
            this.validationErrorMessage = 'Ingrese al menos UN criterio de búsqueda para continuar!';
            this.hideTable();
        }
    }

    displayData() {

        if (this.openItems.length == 1 && (this.openItems[0].totCont != null && this.openItems[0].totCont < 0)) {
            if (this.openItems[0].totCont == -1) {
                //No results found related to your search, Please try different criteria.
                this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');
            } else {
                //Your search resulted in too many items.\nPlease refine your search.
                this.notificationService.open('La búsqueda resultó en demasiados elementos.\nPor favor disminuya los criterios y vuelva a internar.', 'warn');
            }
            this.hideTable();
        } else {
            //this.dataSource = new MatTableDataSource<ReportRemito>(response);
            this.dataSource.data = process(this.openItems as any[], this.state);
            this.showReportData = true;
            this.setPagination();
        }
    }

    setPagination() {
        this.dataSource.paginator = this.paginator;
    }

    getSearchData() {

        this.remitos = new Remito();

        this.getAlmacenSearchCriteria()
        this.getSolicitanteSearchCriteria();
        this.getFecARetornarSearchCriteria();
    }

    getAlmacenSearchCriteria() {
        this.remitos.almacens = [];
        this.chosenAlmacens = [];
        this.selectedAlmacens = "";
        if (this.almacenSelected && this.almacenControl.value != [] && this.almacenControl.value != null && this.almacenControl.value[0] != '-1' && this.almacenControl.value.length != 0) {
            for (let i = 0; i < this.almacenControl.value.length; i++) {
                this.chosenAlmacens.push(this.almacenControl.value[i].split("-")[0].trimEnd());
            }
            this.remitos.almacens = this.chosenAlmacens;
            for (let i = 0; i < this.almacenControl.value.length; i++) {
                this.selectedAlmacens = (this.almacenControl.value[i].split(",")[0].trimEnd()) + "," + this.selectedAlmacens;
            }
            this.remitos.selectedAlmacens = this.selectedAlmacens;
        } else {
            this.remitos.almacens = [""];
        }
    }

    getSolicitanteSearchCriteria() {

        if (this.solicitanteControl.value != '' && this.solicitanteControl.value != '-1') {
            // @ts-ignore
            var solicitanteArr = this.solicitanteControl.value.split("-");
            this.remitos.idSolicitante = solicitanteArr[0].trimEnd();
            this.remitos.nameSolicitante = solicitanteArr[1];
        } else {
            this.remitos.idSolicitante = "-1";
            this.remitos.nameSolicitante = "-1";
        }
    }

    getFecARetornarSearchCriteria() {

        // @ts-ignore
        if (this.fecARetornarControl.value == null) {
            this.remitos.fecARetornar = null;
        } else {
            this.remitos.fecARetornar = this.fecARetornarControl.value;
            // @ts-ignore
            this.remitos.fecARetornar = new Date(this.remitos.fecARetornar.getTime()).toISOString().slice(0, 10);
        }
    }

    hideTable() {
        this.showReportData = false;
        this.dataSource.data = [];
    }

    private checkPrintedRemito() {
        if (this.printRemito === true) {
            if (this.showReportData === false) {
                this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');
            } else {
                this.openItemService.downloadOpenRemitoPdf(this.remitos).subscribe({
                    next: (response) => {
                        const newBlob = new Blob([response], {type: 'application/pdf'});
                        const data = window.URL.createObjectURL(newBlob);
                        const link = document.createElement('a');
                        link.href = data;

                        let date = new Date();
                        let d = date.toLocaleDateString('es-ar', {timeZone: 'America/Argentina/Buenos_Aires'});
                        let t = date.toLocaleTimeString('es-ar', {timeZone: 'America/Argentina/Buenos_Aires'});

                        // @ts-ignore
                        link.download = "Remitos pendientes de retorno+"
                          + d.replace(/\//g, '-') + "+"
                          + t.replace(/:/g, '-') + `.pdf`;
                        link.click();
                        this.isLoading = false;
                    },
                    error: (error) => {
                        this.notificationService.open(this.notificationService.getErrorByCode(error.errorCode), 'error')
                        this.isLoading = false;
                    }
                })
            }
        }
        this.printRemito = false;
    }
}
